import { FunctionComponent } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as styles from './SectionTitle.module.scss';

export type SectionTitleProps = {
  title: string;
  isDrawerOpen: boolean;
  handleToggleDrawer: () => void;
};

export const SectionTitle: FunctionComponent<SectionTitleProps> = ({
  title,
  isDrawerOpen,
  handleToggleDrawer,
}) => {
  const toggleIcon = isDrawerOpen ? faChevronUp : faChevronDown;

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      <button className={styles.drawerToggleButton} onClick={handleToggleDrawer}>
        <FontAwesomeIcon icon={toggleIcon} />
      </button>
    </div>
  );
};
